/* VersionControlDetailsViewRenderer.js */

"use strict";

const Forms = require("@gluenetworks/forms");
const FormsComponent = Forms.ui.component;

require("moment-duration-format");

class VersionControlDetailsViewRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("version-control-details-view-gl");
        this._rootElem.component = this._model;
        this._logger = this._model.logger;
        this._formsComponent = new FormsComponent();
        this._renderingForm = false;
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/

    shutdown() {
        let promArr = [this._formsComponent.shutdown()];

        return Promise.all(promArr).then(
            () => {
                this._model = undefined;
                this._rootElem.remove();
                this._rootElem = undefined;
                this._logger = undefined;
                this._formsComponent = undefined;
                this._renderingForm = undefined;
            },
            (err) => {
                this._logger.warn(
                    {error: err},
                    "VersionControlDetailsViewRenderer.shutdown() error."
                );
            }
        );
    }

    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        if (!this._rootElem.hasChildNodes()) {
            this._rootElem.appendChild(this._formsComponent.renderer.rootElement);
        }
        return this._model.whenModelIsReady().then(
            () => this._renderDetails(),
            (err) => err
        );
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START PRIVATE ACTION METHODS            */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE ACTION METHODS              */
    /* START PRIVATE RENDER METHODS            */
    /*******************************************/

    _renderDetails() {
        return Promise.resolve().then(
            () => {
                let jtype = this._getJtype();
                let pristineValue = this._getPristineValue();
                this._formsComponent.setTypeInformation(jtype, true);
                this._formsComponent.setPristineValue(pristineValue, true);

                this._renderingForm = true;
                return this._formsComponent.renderer.render().then(() => {
                    this._renderingForm = false;
                });
            },
            (err) => {
                this._logger.warn(
                    {error: err},
                    "VersionControlDetailsViewRenderer._renderDetails() error."
                );
            }
        );
    }

    /*******************************************/
    /* END PRIVATE RENDER METHODS              */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/

    _getPristineValue() {
        return this._model.pristineValues;
    }

    _getJtype() {
        return this._model.jType;
    }

    /*******************************************/
    /*  END PRIVATE API METHODS                */
    /*******************************************/
}

module.exports = VersionControlDetailsViewRenderer;
